/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Attach_Files_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to upload files or media in text channels." |
*
* @param {Leveling_Perm_Attach_Files_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_attach_files_hint = /** @type {((inputs?: Leveling_Perm_Attach_Files_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Attach_Files_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам загружать файлы и медиа в текстовые каналы.")
	return /** @type {LocalizedString} */ ("Allows members to upload files or media in text channels.")
});